import { Serializable } from '@dynameat/models';

export class PriceChange extends Serializable {
  constructor(productGuid, group, serviceGuid, saleRateGuid, price) {
    super();
    this.productGuid = productGuid;
    this.group = group;
    this.serviceGuid = serviceGuid;
    this.saleRateGuid = saleRateGuid;
    this.price = price;
  }

  serialize() {
    return {
      product: this.productGuid,
      demand_type: this.group,
      service: this.serviceGuid,
      sale_rate: this.saleRateGuid,
      price: this.price,
    };
  }
}
